/* eslint-disable dot-notation */
// import StepperComponent from '../../reusable/stepper';
// import MapperTwoComponent from './mapper_2';
import CardWrapper from '../../wrapper/card';
import CustomDropdown from '../../reusable/dropdown';
import MapperOneComponent from './mapper_1';
import { saveMappingLeadsThunk } from '../../../redux/thunks/lead';
import { settingFormManualMapping } from '../../../redux/slices/form';
import { toast } from 'react-toastify';
import { useState } from 'react';
import { AppDispatch, RootState } from '../../../redux/store';
import { Box, Button, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';

const destinationRootHeader = [
    { value: 'Title', key: 'title' },
    { value: 'Email', key: 'email' },
    { value: 'Company Name', key: 'company' },
    { value: 'Phone Number', key: 'phone' },
    { value: 'Address', key: 'address' },
    { value: 'City', key: 'city' },
    { value: 'State', key: 'state' },
    { value: 'Zip', key: 'zip' },
    { value: 'Country', key: 'country' }
];

const FormMapping = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams();
    const { manual, loaders } = useSelector((state: RootState) => state.form);
    // const [activeStep, setActiveStep] = useState(0);
    const [selectedRow, setSelectedRow] = useState(1);

    const handleCancelButton = () => {
        // if (activeStep === 1) {
        //     setActiveStep(0);
        //     return;
        // }
        dispatch(settingFormManualMapping({
            selectedForm: null,
            isManual: false,
            headers: [],
            rows: [],
            mapping: {}
        }));
    };

    const SubmitButtonHandler = async () => {
        // const checkEntries = Object.entries(manual.mapping);
        // if (checkEntries.length < manual.rows.length) {
        //     toast.error('Please Map Out Fields for Leads ', {
        //         position: 'top-left',
        //         autoClose: 5000,
        //         theme: 'dark'
        //     });
        //     return;
        // }
        // if (activeStep === 1) {
        try {
            const customToHeader = {
                title: manual.mapping['Title'],
                email: manual.mapping['Email'],
                company: manual.mapping['Company Name'],
                phone: manual.mapping['Phone Number'],
                address: manual.mapping['Address'],
                country: manual.mapping['Country'],
                zip: manual.mapping['Zip'],
                state: manual.mapping['State'],
                city: manual.mapping['City']
            };
            const fieldIndexMap = Object.fromEntries(Object.entries(customToHeader).map(([key, val]) => [key, val ?? null]));
            // await console.log(fieldIndexMap);
            const data = {
                form_id: manual.selectedForm?.id,
                mapping_json: JSON.stringify(fieldIndexMap)
            };
            // await console.log(fieldIndexMap);
            await dispatch(saveMappingLeadsThunk({ data, client_id: id ? parseInt(id as string, 10) : 0 }));
            handleCancelButton();
        } catch (e) {
            //
        }
        // return;
        // }
        // setActiveStep(1);
    };

    return (
        <Box>
            <Box p={1} minHeight="80vh" overflow="auto">
                <CardWrapper>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Box></Box>
                        <Box display="flex" flexDirection="column">
                            {/* <Box display="flex" alignItems="center" justifyContent="center" mb={2}>
                                <StepperComponent
                                    steps={[
                                        '1',
                                        '2'
                                    ]}
                                    activeStep={activeStep}
                                />
                            </Box> */}
                            <Typography variant="h4" fontWeight="bold" align="center" color="textSecondary">Please Map Out Fields for Leads</Typography>
                        </Box>
                        <Box>
                            {/* <CustomDropdown
                                value={selectedRow}
                                onChange={(e) => setSelectedRow(e.target.value as number)}
                                options={manual.rows.map((item, index) => ({
                                    label: `${index + 1} Row`,
                                    value: index + 1
                                }))}
                            /> */}
                        </Box>
                    </Box>
                    <MapperOneComponent selectedIndex={selectedRow} destinationRootHeader={destinationRootHeader} />
                    {/* {activeStep === 0 && <MapperOneComponent selectedIndex={selectedRow} destinationRootHeader={destinationRootHeader} />} */}
                    {/* {activeStep === 1 && <MapperTwoComponent selectedIndex={selectedRow} destinationSocialHeader={destinationSocialHeader} />} */}
                    <Box display="flex" justifyContent="end" gap={2} alignItems="center">
                        <Button variant="outlined" color="secondary" size="large" disabled={loaders.isCreating} onClick={handleCancelButton}>Cancel</Button>
                        <Button variant="contained" size="large" disabled={loaders.isCreating} onClick={SubmitButtonHandler}>Save</Button>
                    </Box>
                </CardWrapper>
            </Box>
        </Box>
    );
};

export default FormMapping;
